module.exports = __webpack_public_path__ + "img/carline_2.87cbacf3.png";